import { Flex, Tabs } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const TrapManagementPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const MobileHeaderWrapper = styled.header`
  margin-top: 16px;
  padding-left: 16px;
`;

export const StyledTrapManagementTabs = styled(Tabs)`
  display: flex;
  flex-direction: column;
  height: 100%;

  @media (max-width: 768px) {
    height: auto;
    flex: 1;
    min-height: 0;
  }

  .ant-tabs-content-holder {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  .ant-tabs-content {
    height: 100%;
  }

  .ant-tabs-nav {
    margin: 16px 24px;

    @media (max-width: 768px) {
      margin: 0;
    }

    .ant-tabs-nav-wrap {
      justify-content: flex-end;

      @media (max-width: 768px) {
        justify-content: flex-start;
      }
    }

    &:before {
      border-color: ${COLOR_OPTIONS.NEUTRAL_30};
    }

    .ant-tabs-nav-list {
      .ant-tabs-tab-disabled {
        margin: 0;

        .ant-tabs-tab-btn {
          display: none;
        }
      }
    }
  }

  .ant-tabs-tab {
    padding: 16px 0;
  }

  && .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
      svg {
        color: ${COLOR_OPTIONS.BLUE_60};
      }
    }
  }

  .ant-tabs-tab-btn {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: ${COLOR_OPTIONS.NEUTRAL_100};

    .ant-tabs-tab-icon {
      display: flex;

      svg {
        color: ${COLOR_OPTIONS.NEUTRAL_60};
      }
    }
  }

  .ant-tabs-tabpane {
    margin: 0 24px;
    height: 100%;

    @media (max-width: 768px) {
      margin: 0 20px;
    }
  }

  @media (max-width: 768px) {
    .ant-tabs-nav {
      flex-direction: column;
      align-items: stretch;

      .ant-tabs-extra-content {
        margin-bottom: 12px;
      }

      .ant-tabs-nav-wrap {
        justify-content: flex-start;
        overflow-x: auto;
        scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none;
        }

        &::before,
        &::after {
          box-shadow: none;
        }
      }

      .ant-tabs-nav-list {
        transform: none !important;
      }

      .ant-tabs-nav-operations {
        display: none;
      }
    }
  }
`;

export const FilterWrapper = styled.div`
  padding-bottom: 16px;
  padding-top: 8px;

  @media (max-width: 768px) {
    padding-top: 20px;
  }
`;

export const EmptyStateWrapper = styled(Flex).attrs({
  vertical: true,
  align: 'center'
})`
  background-color: ${COLOR_OPTIONS.NEUTRAL_00};
  padding: 36px 16px 52px 16px;
  border-radius: 8px;
  border: 1px solid ${COLOR_OPTIONS.NEUTRAL_20};
`;
